module.exports = __webpack_public_path__ + "assets/bottom-nav-chat.1adcff08.svg";